/**
 * Step 0 observability: counts stall-repair resyncs that would previously have
 * been covered by HTTP polling. High counts while sockets are connected indicate
 * missing event coverage.
 */
declare global {
  interface Window {
    __realtimeRepairMetrics?: {
      repairs: Partial<Record<string, number>>;
    };
  }
}

export function incrementPollWonRepair(group: string, reason: string) {
  if (typeof window === 'undefined') {
    return;
  }
  const key = `${group}:${reason}`;
  const store = window.__realtimeRepairMetrics ?? { repairs: {} };
  store.repairs[key] = (store.repairs[key] ?? 0) + 1;
  window.__realtimeRepairMetrics = store;
}
